export default {"src":"/_next/static/media/mapPinIcon.09172347.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};